import { Document } from 'services/DocumentService'
import {
  SET_DOCUMENT_KEYWORD,
  SET_DOCUMENT_FAVOURITES_ONLY,
  SET_SELECTED_DOCUMENTS,
  SET_DOCUMENT_AUTOMATED_ONLY
} from './types'
import { DOCUMENT_AUTOMATED_ONLY_KEY, DOCUMENT_FAVOURITES_ONLY_KEY } from 'constants/storage-keys'

export const setDocumentKeyword = (keyword: string): { type: typeof SET_DOCUMENT_KEYWORD, keyword: string } => ({
  type: SET_DOCUMENT_KEYWORD,
  keyword
})

export const setDocumentShowFavouritesOnly = (show: boolean): { type: typeof SET_DOCUMENT_FAVOURITES_ONLY, showFavouritesOnly: boolean } => {
  localStorage.setItem(DOCUMENT_FAVOURITES_ONLY_KEY, JSON.stringify(show))
  return {
    type: SET_DOCUMENT_FAVOURITES_ONLY,
    showFavouritesOnly: show
  }
}

export const setDocumentShowAutomatedOnly = (show: boolean): { type: typeof SET_DOCUMENT_AUTOMATED_ONLY, showAutomatedOnly: boolean } => {
  localStorage.setItem(DOCUMENT_AUTOMATED_ONLY_KEY, JSON.stringify(show))
  return {
    type: SET_DOCUMENT_AUTOMATED_ONLY,
    showAutomatedOnly: show
  }
}

export const setSelectedDocuments = (selected: Document[]): { type: typeof SET_SELECTED_DOCUMENTS, selected: Document[] } => ({
  type: SET_SELECTED_DOCUMENTS,
  selected
})
